import axios from 'axios'
import store from '@/store'

export default {
  getPartners (params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/finances/partners${params}`, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            store.dispatch('partners/setPartners', res.data)
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  createPartner (params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/finances/partners/`, params, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  removePartner  (id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/finances/partners/${id}`, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  editPartner (params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/finances/partners/${params.id}`, params, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  getAllPartners () {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/finances/all-partners', {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            store.dispatch('partners/setAllPartners', res.data)
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  }
}
